/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'options-dot': {
    width: 22,
    height: 21,
    viewBox: '0 0 22 21',
    data: '<circle pid="0" cx="2.881" cy="10.5" r="1.5" transform="rotate(-90 2.881 10.5)" _fill="#97B2C4"/><circle pid="1" cx="10.881" cy="10.5" r="1.5" transform="rotate(-90 10.881 10.5)" _fill="#97B2C4"/><circle pid="2" cx="18.881" cy="10.5" r="1.5" transform="rotate(-90 18.881 10.5)" _fill="#97B2C4"/>'
  }
})
